@import "prism-code-editor/themes/prism-solarized-light.css";
